var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportationInsecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_4048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.8125,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_4048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4791V14.1458C4.5 14.3347 4.43611 14.493 4.30833 14.6208C4.18056 14.7486 4.02222 14.8125 3.83333 14.8125H3.16667C2.97778 14.8125 2.81944 14.7486 2.69167 14.6208C2.56389 14.493 2.5 14.3347 2.5 14.1458V8.81248L3.9 4.81248C3.96667 4.61248 4.08611 4.45137 4.25833 4.32915C4.43056 4.20692 4.62222 4.14581 4.83333 4.14581H12.1667C12.3778 4.14581 12.5694 4.20692 12.7417 4.32915C12.9139 4.45137 13.0333 4.61248 13.1 4.81248L14.5 8.81248V14.1458C14.5 14.3347 14.4361 14.493 14.3083 14.6208C14.1806 14.7486 14.0222 14.8125 13.8333 14.8125H13.1667C12.9778 14.8125 12.8194 14.7486 12.6917 14.6208C12.5639 14.493 12.5 14.3347 12.5 14.1458V13.4791H4.5ZM4.36667 7.47915H12.6333L11.9333 5.47915H5.06667L4.36667 7.47915ZM5.5 11.4791C5.77778 11.4791 6.01389 11.3819 6.20833 11.1875C6.40278 10.993 6.5 10.7569 6.5 10.4791C6.5 10.2014 6.40278 9.96526 6.20833 9.77081C6.01389 9.57637 5.77778 9.47915 5.5 9.47915C5.22222 9.47915 4.98611 9.57637 4.79167 9.77081C4.59722 9.96526 4.5 10.2014 4.5 10.4791C4.5 10.7569 4.59722 10.993 4.79167 11.1875C4.98611 11.3819 5.22222 11.4791 5.5 11.4791ZM11.5 11.4791C11.7778 11.4791 12.0139 11.3819 12.2083 11.1875C12.4028 10.993 12.5 10.7569 12.5 10.4791C12.5 10.2014 12.4028 9.96526 12.2083 9.77081C12.0139 9.57637 11.7778 9.47915 11.5 9.47915C11.2222 9.47915 10.9861 9.57637 10.7917 9.77081C10.5972 9.96526 10.5 10.2014 10.5 10.4791C10.5 10.7569 10.5972 10.993 10.7917 11.1875C10.9861 11.3819 11.2222 11.4791 11.5 11.4791ZM3.83333 12.1458H13.1667V8.81248H3.83333V12.1458Z",
    fill: "#63666A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportationInsecurity);
export default __webpack_public_path__ + "static/media/Transportation Insecurity.179c7105ccbb24b3ddbe1dbaa109c5a7.svg";
export { ForwardRef as ReactComponent };